














// 根据type动态引入echarts依赖
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import echarts from 'echarts'
const defaultOption = {
  title: {
    text: '标题',
    left: 'center',
    top: 15,
  },
  legend: {
    bottom: 20,
    right: 40,
    left: 40,
  },
  series: [
    {
      type: 'pie',
      radius: ['35%', '50%'],
      center: ['50%', '45%'],
      selectedMode: 'single',
      data: [
        {
          value: 1548,
          name: '幽州',
        },
        {
          value: 535,
          name: '荆州',
        },
        {
          value: 510,
          name: '兖州',
        },
        {
          value: 634,
          name: '益州',
        },
        {
          value: 735,
          name: '西凉',
        },
      ],
      itemStyle: {
        emphasis: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)',
        },
      },
    },
  ],
}
const data = {
  x: 1,
  selet: '',
  sta: true,
}

@Component
export default class Echarts extends Vue {
  @Prop({ type: Object, default: defaultOption }) private value!: Object
  @Prop({ type: String, default: 'pie' }) private type!: String
  @Prop({ type: String, default: '' }) private stype!: String
  @Prop({ type: Boolean, default: true }) private isShowLoading!: Boolean
    @Prop({ type: Boolean, default: false }) private state!: Boolean
  private myCharts: any

  get options() {
    return this.value
  }

  set options(val) {
    this.$emit('input', val)
  }

  private mounted() {
    this.echartsInit()
  }

  // echarts初始化
  private echartsInit() {
    // 初始化echarts
    this.myCharts = echarts.init(this.$refs.myCanvas as any)
    this.isShowLoading && this.showLoading()
    // 设置options
    this.myCharts.setOption(this.options)
    if(this.selectedlist.length>0){
                this.myCharts.setOption({
          legend: { selected: this.selectedlist },
        })
    }
    this.$nextTick(() => {
      this.myCharts.hideLoading()
    })
  }

  private showLoading() {
    this.myCharts.showLoading({
      text: '加载中...',
      maskColor: 'rgba(255, 255, 255, 0.8)',
      color: '#FFC042',
      textColor: '#282828',
      zlevel: 0,
    })
  }
  private selectedlist=[]

  private hideLoading() {
    this.myCharts.hideLoading()
  }

  // 数据更新
  @Watch('options', { immediate: false, deep: true })
  private optionsUpdate(nowval: object) {
    this.myCharts.clear()
    // console.log(this.stype)

    // this.isShowLoading && this.showLoading()
    this.myCharts.setOption({ ...nowval }) // 赋值变化值
    // console.log(this.state)
    console.log(1233);
    

    if (this.state) {
    // this.echartsInit()
    console.log(this.selectedlist);

                this.myCharts.setOption({
          legend: { selected: this.selectedlist },
        })
            if(this.selectedlist.length>0){
    }else{

 
      this.myCharts.off('legendselectchanged')
            this.myCharts.on('legendselectchanged', (e) => {
              console.log(e);
              let obj = e.selected
              this.selectedlist = obj

                 this.myCharts.setOption({
          legend: { selected: obj },
        })
              
            })
               }


    } else {
    //  this.echartsInit()
    //  console.log(2);
      this.myCharts.off('legendselectchanged')

      this.myCharts.on('legendselectchanged', (e) => {
      // console.log(e)
        let obj = e.selected

        if (data.selet === e.name) {
          data.selet = ''
          data.x = 2
        } else {
          data.selet = e.name
          data.x = 1
        }
        // console.log(data.x);

        let xz = e.selected
        Object.keys(xz).forEach((key) => {
          xz[key] = true
        })
        if (data.x === 1) {
          Object.keys(obj).forEach((key) => {
            if (key === e.name) {
              obj[key] = true
            } else {
              obj[key] = false
            }
          })

          if (this.stype === 'dev') {
            this.$emit('changemsg', e.name)
          // 判断是不是单元分析，然后传值过去
          }
        } else {
          obj = xz
        }
        // console.log(obj)

        this.myCharts.setOption({
          legend: { selected: obj },
        })
      })
    // data.selet = ''
    // data.x= 1
    }
    this.isShowLoading && this.hideLoading() // 隐藏loading
  }
  @Watch('state')
  private x(nowval:boolean) {
    // console.log(nowval);
    this.myCharts.clear()
    this.myCharts.setOption(this.options)
    if (this.state) {
    // this.echartsInit()
    console.log(2);

      this.myCharts.off('legendselectchanged')
    } else {
    //  this.echartsInit()
    //  console.log(2);
      this.myCharts.off('legendselectchanged')

      this.myCharts.on('legendselectchanged', (e) => {
      // console.log(e)
        let obj = e.selected

        if (data.selet === e.name) {
          data.selet = ''
          data.x = 2
        } else {
          data.selet = e.name
          data.x = 1
        }
        // console.log(data.x);

        let xz = e.selected
        Object.keys(xz).forEach((key) => {
          xz[key] = true
        })
        if (data.x === 1) {
          Object.keys(obj).forEach((key) => {
            if (key === e.name) {
              obj[key] = true
            } else {
              obj[key] = false
            }
          })

          if (this.stype === 'dev') {
            this.$emit('changemsg', e.name)
          // 判断是不是单元分析，然后传值过去
          }
        } else {
          obj = xz
        }
        // console.log(obj)

        this.myCharts.setOption({
          legend: { selected: obj },
        })
      })
    // data.selet = ''
    // data.x= 1
    }

    // this.echartsInit()
  }
}
